import { history } from '@umijs/max';
const getSearchObject: () => Record<string, any> = () => {
    let search = history.location.search;

    if (search) {
        return search
            .slice(1)
            .split('&')
            .reduce((total, item) => {
                const items = item.split('=');
                const key = items.shift();
                if (key) {
                    total[key] = items.join('=');
                }

                return total;
            }, {});
    }

    return {};
};

export default getSearchObject;
